<template>
    <v-toolbar extended flat id="topBar" :height=60 :extension-height=40 app>
        <v-container fluid fill-height grid-list-md style="padding:5px;">
            <v-layout row>
                <img height="50" :src=logo alt="">
                <div style="color:white;margin:10px;padding:5px;font-size:20px;font-weight:bold;display:flex;justify-content:center;align-items:center;">WiDE Online</div>
                <v-spacer></v-spacer>
                <div style="margin:0px 10px 0px 10px;">
                    <div style="color:white;display:flex;justify-content:flex-end;align-items:center;height:50%;">{{userName}}</div>
                    <div style="color:rgb(218,218,218);display:flex;justify-content:flex-end;align-items:center;height:50%;">{{companyName}}</div>
                </div>
                <v-menu bottom left offset-y>
                    <template v-slot:activator="{on}">
                        <v-avatar tile="true" v-on="on">
                            <img style="width:24px;height:24px;" :src="burger" alt="">
                        </v-avatar>
                    </template>
                    <v-list>
                        <v-list-tile v-for="item in items" :key="item" v-on:click="menuSelect(item)">
                            <v-list-tile-title>{{ item }}</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-layout>
        </v-container>
    </v-toolbar>
</template>

<script>

    // import AlertMenu     from "./AlertMenu"
    import {store} from "../main.js"

    export default {
        name: "Topbar",
        components: {
            // AlertMenu
        },
        props: {
            userName: String,
            companyName: String
        },
        data: function () {
            return {
                logo: require('../assets/WiDE_Logo_Light.png'),
                burger: require('../assets/burger_active_dark.png'),
                notif: require('../assets/notifications.png'),
                ticket: require('../assets/ticket.png'),
                user: require('../assets/estLogo.png'),
                items: ['Logout'],//[ 'Report','Settings','Logout'],
                showAlert: false,
                alertMenu: false,
                X: 0,
                Y: 0
            }
        },
        methods: {
            menuSelect(menuItem) {
                if (menuItem == "Settings") this.$router.push({path: '/user-settings'});
                else if (menuItem == "Report") this.$router.push({path: '/report'})
                else {
                    store.userLogged = false;
                    window.$cookies.remove('user');
                    this.$router.push({path: '/login'});
                }
            },
        },
        computed: {},
        watch: {}
    }
</script>

<style scoped>
    #topBar {
        background-color: rgb(144, 170, 218);
        padding: 0px;
    }


</style>
